import type { ConfirmPurchaseOrderNotificationConfig } from '../../../../domain/types/configs/company/NotificationConfig';

export const confirmPurchaseOrderNotificationConfig: ConfirmPurchaseOrderNotificationConfig = {
  recipients: [
    {
      contact: "ap@cooweb.co",
      company: "PROMED",
      send: false
    }
  ]
}; 